import { render } from "./customers.vue?vue&type=template&id=8f098f2c&scoped=true&ts=true"
import script from "./customers.vue?vue&type=script&lang=ts"
export * from "./customers.vue?vue&type=script&lang=ts"

import "./customers.vue?vue&type=style&index=0&id=8f098f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f098f2c"]])

export default __exports__